import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector} from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import {  SECONDORY_COLOR, formatCurrency, labelText } from "../common/sharedFunctions";
import moment from "moment";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';

export default function Earningreports() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  
  const settings = useSelector(state => state.settingsdata.settings);

  const columns =  [
    { title: labelText(t, 'booking_ref', 'Booking Reference'), field: 'bookingReference'},
    { title: labelText(t, 'accepted_offer_type', 'Accepted Offer Type'), field: 'acceptedOfferType'},
    { title: labelText(t, 'garahex_commission_payer', 'Payer of Garahex Commission'), field: 'payerRole'},
    { title: labelText(t, 'gross_bid_amount', 'Gross Bid Amount'), field: 'grossAmount', render: rowData => formatCurrency(rowData.grossAmount || 0, settings)},
    { title: labelText(t, 'commission_type', 'Commission Type'), field: 'commissionType'},
    { title: labelText(t, 'commission_rate', 'Commission Rate'), field: 'commissionRate'},
    { title: labelText(t, 'commission_amount', 'Commission Amount'), field: 'commissionAmount', render: rowData => formatCurrency(rowData.commissionAmount || 0, settings)},
    { title: labelText(t, 'net_payee_amount', 'Net Payee Amount'), field: 'netPayeeAmount', render: rowData => formatCurrency(rowData.netPayeeAmount || 0, settings)},
    { title: labelText(t, 'booking_status_web', 'Booking Status'), field: 'bookingStatus'},
    { title: labelText(t, 'deduction_status', 'Deduction Status'), field: 'deductionStatus'},
    { title: labelText(t, 'deducted_at', 'Deducted At'), field: 'deductedAt', render: rowData => rowData.deductedAt ? moment(rowData.deductedAt).format('lll') : ""},
    { title: labelText(t, 'source', 'Source'), field: 'source'}
  ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(()=>{
        if(earningreportsdata.Earningreportss){
            setData(earningreportsdata.Earningreportss);
        }
  },[earningreportsdata.Earningreportss]);

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    earningreportsdata.loading? <CircularLoading/>:
    <ThemeProvider theme={theme}>
      <MaterialTable
        title={t('earning_reports_title')}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        }}
        data={data}
        
        onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        options={{
          exportButton: true,
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
          }),
          ...TableStyle()
        }}
        localization={localization(t)}
      />
    </ThemeProvider>
  );
}
